import constants from "../constants";
import { get, getQueryString, post } from "../utils";

export const getReceivingListData = (payload: any) => {
  const URL = constants.COMMON_SERVICES_BASE_URL + "v1/common/receivings/list";
  return post(URL, payload, true, true, false);
};

export const getReceivingVendorList = ({
  storeId,
  fromDate,
  toDate,
  signal
}: {
  storeId: any;
  fromDate: string;
  toDate: string;
  signal?: AbortSignal | null;
}) => {
  const queryString = getQueryString({
    storeId,
    fromDate,
    toDate
  });

  const URL =
    constants.COMMON_SERVICES_BASE_URL +
    "v1/common/receivings/vendors?" +
    queryString;
  return get(URL, true, true, false, signal);
};

export const getSearchProductsForJITOrder = (payload: {
  searchTerm: string;
  departmentId: string;
  signal?: AbortSignal;
}) => {
  const { searchTerm, departmentId, signal } = payload;
  const reqPayload = {
    searchText: searchTerm,
    departmentId,
    isViewAll: false,
    limit: 50
  };
  const URL =
    constants.COMMON_SERVICES_BASE_URL + "v1/common/product/search";
  return post(URL, reqPayload, true, true, false, signal);
};
